const deps = [
  'bench.main-app',
  require('angular-ui-router'),
  require('ui/bk/generalLedger').name,
  require('data/user').name,
];

const { loadReportingInterval, saveReportingInterval } = require('bk-web-app');

module.exports = angular
  .module('bench.app.mainapp.generalledger', deps)
  .config(($stateProvider, MainAppConfig) => {
    const stateName = 'bench.generalledger';
    const path = MainAppConfig.routes[stateName];
    return $stateProvider.state(stateName, {
      url: `${path}?startDate&endDate&{showAccounts:bool}&{showComments:bool}&{showQualityIssues:bool}&search&sidebarElementId&sidebarType`,
      params: {
        startDate: undefined,
        endDate: undefined,
        search: undefined,
        sidebarElementId: undefined,
        sidebarType: undefined,
        showAccounts: {
          value: false,
          squash: true,
        },
        showComments: {
          value: true,
          squash: true,
        },
        showQualityIssues: {
          value: true,
          squash: true,
        },
      },
      views: {
        '': {
          controller($state, $window, $stateParams, User) {
            this.userId = User.userId;
            this.clientId = $stateParams.clientId;
            this.dateRange = {
              endDate: $stateParams.endDate,
              startDate: $stateParams.startDate,
            };
            this.sidebarDescriptor =
              $stateParams.sidebarElementId && $stateParams.sidebarType
                ? {
                    sidebarElementId: $stateParams.sidebarElementId,
                    sidebarType: $stateParams.sidebarType,
                  }
                : undefined;
            this.filters = {
              search: $stateParams.search,
              showAccounts: !!$stateParams.showAccounts,
              showComments: !!$stateParams.showComments,
              showQualityIssues: !!$stateParams.showQualityIssues,
            };
            this.setLocationParams = newState => {
              if (newState.startDate && newState.endDate) {
                saveReportingInterval(this.clientId, newState);
              }

              return $state.go('.', newState, { notify: false });
            };

            if (!this.dateRange.startDate || !this.dateRange.endDate) {
              const storedInterval = loadReportingInterval(this.clientId);
              if (storedInterval) {
                this.dateRange = storedInterval.dateRange;
                this.setLocationParams(storedInterval.dateRange);
              }
            }
          },
          controllerAs: 'vm',
          template: `
              <general-ledger
                client-id="vm.clientId"
                user-id="vm.userId"
                date-range="vm.dateRange"
                filters="vm.filters"
                set-location-params="vm.setLocationParams"
                sidebar-descriptor="vm.sidebarDescriptor"
              >
              </general-ledger>
            `,
        },
      },
    });
  });
